<template>
  <div class="telecom-ad">
    <!-- 头部横幅 -->
    <img 
      src="@/assets/gzdxAd/banner.png" 
      alt="中国电信活动横幅" 
      class="banner"
    />
    
    <!-- 表单区域 -->
    <div class="form-container">
      <!-- 倒计时 -->
      <div class="countdown">
        <span class="countdown-title">距离活动结束还剩：</span>
        <div class="countdown-time">
          <span class="time-block">{{ formatTime(countdown.hours) }}</span>
          <span class="time-colon">时</span>
          <span class="time-block">{{ formatTime(countdown.minutes) }}</span>
          <span class="time-colon">分</span>
          <span class="time-block">{{ formatTime(countdown.seconds) }}</span>
          <span class="time-colon">秒</span>
        </div>
      </div>
      
      <!-- 表单 -->
      <van-form @submit="onSubmit" :label-width="0">
        <div class="form-group">
          <label class="form-label">
            <span class="required">*</span>
            领卡姓名
          </label>
          <van-field
            v-model="formData.name"
            name="name"
            placeholder="输入办理人姓名（已加密）"
            class="form-field"
            :rules="[{ required: true, message: '请输入姓名' }]"
          />
        </div>
        
        <div class="form-group">
          <label class="form-label">
            <span class="required">*</span>
            联系电话
          </label>
          <van-field
            v-model="formData.phone"
            name="phone"
            type="tel"
            placeholder="输入有效联系电话并保持畅通"
            maxlength="11"
            class="form-field"
            :rules="phoneRules"
          />
        </div>
        
        <van-button 
          type="primary" 
          native-type="submit" 
          class="submit-btn"
          :loading="submitting"
        >
          立即领取 包邮到家
        </van-button>
      </van-form>
      
      <!-- 滚动通知 -->
      <div class="marquee">
        <div class="scroll-content">
          <div 
            v-for="(item, index) in marqueeData" 
            :key="index" 
            class="marquee-item"
          >
            <span class="user-name">{{ item.name }}</span>
            <span class="user-phone">{{ item.phone }}</span>
            <span class="user-time">{{ item.time }}分钟前已领取</span>
          </div>
        </div>
      </div>
      
      <!-- 协议 -->
      <div class="agreement">
        <van-checkbox v-model="formData.agreed" :label-width="0">
          <span class="agreement-text">
            填写并提交视为阅读并同意
            <a href="#" @click.prevent="showAgreement('privacy')">《个人信息保护政策》</a>
            <a href="#" @click.prevent="showAgreement('consent')">《单独同意书》</a>
            <a href="#" @click.prevent="showAgreement('contract')">《中国电信用户入网协议》</a>
          </span>
        </van-checkbox>
      </div>
      
      <p class="text-center notice-text">
        *具体活动规则以实际产品为准
      </p>
    </div>
    
    <!-- 产品图片 -->
    <div class="product-images">
      <img src="@/assets/gzdxAd/product1.png" alt="产品介绍1">
      <img src="@/assets/gzdxAd/product2.png" alt="产品介绍2">
      <img src="@/assets/gzdxAd/product3.jpg" alt="产品介绍3">
      <img src="@/assets/gzdxAd/product4.jpg" alt="产品介绍4">
    </div>
    
    <!-- 温馨提示 -->
    <div class="tip-section">
      <p class="tip-text">
        如用户因运营商审核未通过未能成功办理或自身原因未激活，我司将自动推荐符合办理条件的其他运营商产品发货，用户可根据实际情况进行拒收或办理
      </p>
    </div>
    
    <!-- 详情折叠区域 -->
    <div class="details-section">
      <van-button v-if="!showDetails"
        class="details-toggle" 
        @click="toggleDetails"
        plain
      >
        资费详细说明
      </van-button>
      <div class="details-content" :class="{ show: showDetails }">
        <h3 class="details-title">【资费详情】</h3>
        <div class="details-text">
          <p>1、原月租29元，套餐内含30GB爱奇艺腾讯视频、优酷视频、西瓜视频、抖音短视频、抖音火山版、快手网易云音乐等应用定向流量，全国接听不收费，套餐内含来电显示天翼云盘-普通版、189邮箱-不收费版。</p>
          <br>
          <p>充值100元后48小时内叠加50G通用流量，有效期24个月，当月有效，不可结转到次月。</p>
          <br>
          <p>2、激活充值100元,可享受如下优惠:</p>
          <p>（1）激活当月赠送30元话费订购立即到账,激活即可使用,不退返现金,不可抵扣国际业务、港澳台业务通信费和SP/CP等价代收费用,赠送话费仅激活当月有效,促销协议期1个月,到期自动退订。</p>
          <p>（2）激活后,预存100元得50GB国内流量权益。</p>
          <p>（3）预存获得权益使用规则: </p>
          <p>预存100元成功后立即到账,可抵扣所有话费。</p>
          <p>获得50G国内流量权益,自订购生效当月起连续24个月每月获得50GB国内流量,流量当月有效、跨月无效;流量为国内流量,限在中国大陆境内(不含港澳台地区)使用,可用于中国电信现有移动通信网络,不含WLAN(Wi-Fi)上网;获得的流量权益不计入套餐外流量封顶及费用封顶值计算。</p>
          <p>（4）与自身互斥,预存优惠互斥,与其他流量套餐、无线宽带套餐,时长计费套餐互斥。</p>
          <p>（5）与其它话费补贴优惠、终端补贴优惠互斥。</p>
          <p>（6）流量有效期为24个月,到期自动失效;有效期内仅可办理一次。</p>
          <br>
          <p>3、激活后立即生效。首月执行过渡期资费，订购当月套餐月基本费按日计扣(入网当日到月底)，费用四舍五入到分;套餐内容(语音、流量)按照对应流量和分钟数按天折算，向上取整。</p>
          <p>4、全国接听不收费，套餐内含来电显示和189邮箱。</p>
          <p>5、套餐超出资费</p>
          <p>(1)国内通用流量:前 167MB 按 0.03 元/MB 收费，达到 167MB 时，额外享受 857MB 流量(即 5 元/GB);后续 仍按上述规则收费(即每超出 1GB 按照 5 元/GB 收费)</p>
          <p>(2)国内通话:0.1元/分钟</p>
          <p>(3)国内短/彩信:0.1元/条</p>
          <p>(4)其他业务按照标准资费执行</p>
          <p>6、国内通话和接听不收费范围不包括港澳台地区</p>
          <p>7、手机上网流量仅限中国大陆境内使用,不含 WLAN(Wi-Fi)上网</p>
          <p>8、可订购各类流量包、语音包及短/彩信包产品。</p>
          <p>9、上网当月套餐外流量消费 600 元及 600 元的倍数则断 网，次月初自动开通，如果客户当月申请继续使用，则继续 提供服务，按照套外资费收费。套餐外流量消费费用包含按 套餐外资费收取的上网流量费，不含用户订购的定向、闲时 等各种流量包功能费。</p>
          <p>10、为更好地为您提供通话服务，请确保您的手机终端支持电信Volte/高清语音通话功能并开启了“volte/高清语音通话”开关。</p>
          <br>
          <h3 class="details-title">购买须知</h3>
          <p>1.本套餐一个证件只能办理一张，发货后请使用订购人身份证原件按照随卡寄送的单页说明进行激活，若发货后超过20天未激活，系统将回收处理</p>
          <p>2.本套餐办理号码及号码归属地随机。</p>
          <p>3.根据国家相关规定，未满18周岁的用户将不能在网络渠道办理入网，因年龄问题未能激活的用户，请由您的法定代理人前往营业厅代为办理。</p>
          <p>4.本号卡仅满足用户正常使用通话和流量，对于因受业务及物流限制地区可能产生电信诈骗的归属地我们会进行鉴别并不支持发货，敬请见谅。</p>
          <p>5.未满18周岁，一证十号已满(含正在使用的)国政通不通过，军人，保密单位等职业的身份证属于特殊证件无法网上办理通讯业务，故不发货</p>
          <p>6.根据工信部2018年9月1日实名新规要求，您下单时需要填写真实姓名和证件号进行实名验证，套餐电话卡到手后需激活，上传证件正面、反面及本人正面免冠照片，线上登记的机主姓名需与实名开户的机主姓名与证件一致，开户和激活会将信息在国政通联网对比。</p>
          <br>
          <h3 class="details-title">免流规则</h3>
          <p>1.头条系应用包含:今日头条、今日头条 lite 版、西 瓜视频、抖音火山版、抖音短视频、皮皮虾、懂车帝、半次元。2.百度系应用包含:百度APP、百度贴吧、百度地图、百度网盘百度手机助手、百度百科、秒懂百科、百度知道、百度文库、百度输入法、地图淘金、千千音乐、百度翻译、百度新闻、百度浏览器好看视频。其中:手机百度、百度网盘、百度手机助手、百度新闻百度浏览器、好看视频享受免流服务前需先至对应APP进行绑定激活，绑定入口:</p>
          <p>(1)手机百度:[个人中心]-[免流量特权]-[活动页面]-[激活免流]。</p>
          <p>(2)百度网盘:[更多]-[设置]-[免流量特]-[活动页面]-[激活免流](只限百度网盘超级会员绑定激活免流，非会员无法免流)。</p>
          <p>(3)百度手机助手:[管理]-[免流量服务]-[活动页面]-[激活免流]</p>
          <p>(4)好看视频:[我的]-[免流特权]-[活动页面]-[激活免流]。</p>
          <p>注:以上需绑定激活的应用(除百度网盘APP)，在同一手机终端使用时，只需激活其中一款应用，其他应用无需绑定激活即可享受免流服务。</p>
          <p>3、网易系用包含</p>
          <p>网易系非游戏应用:网易云音乐、网易新闻、网易公开课、网易云阅读、网易云课堂、易信、网易蜗牛阅读、网易100分。网易系游戏应用包含:</p>
          <p>梦幻西游、大话西游、阴阳师、荒野行动、终结者</p>
          <p>4、倩女幽魂率土之滨、镇魔曲、三国如龙传、坦克连、决战平安京、我的世界天下、光明大陆、格罗娅传奇。</p>
          <p>5、阿里系定向流量包含:优酷视频5.腾讯视频</p>
          <p>所有APP“专属流量”使用说明</p>
          <p>(一)在电信网络下，使用对应免流APP产生的流量;</p>
          <p>(二)所使用的APP需升级到最新版本;</p>
          <p>(三)注册所有APP手机号码需与本机号码一致。</p>
          <br>
          <h3 class="details-title">不免流范围</h3>
          <p>1、在无线上网卡、移动WIFI、MIFI、平板电脑(如ipad)等设备使用时;</p>
          <p>2、将手机号码作为手机热点使用时;</p>
          <p>3、使用网络加速器、代理服务器、VPN等工具时;</p>
          <p>4、在国际地区、港澳台使用时;</p>
          <p>5、通过APPSTORE或安卓市场等下载/更新应用时:6、应用内开机广告及第三方广告时产生的流量;</p>
          <p>7、应用中访问外部链接或转发到外部应用产生的流量;</p>
          <p>8、APP内直播业务均不免流:</p>
          <p>9、所有APP内的第三方提供的网页(手机百度搜索跳转的第三方网页除外)视频、图片、广告、应用下载等服务，例如手机新闻网搜狗、携程、京东等非百度业务。</p>
        </div>
      </div>
    </div>

    <van-button v-if="showDetails" class="details-toggle"  @click="toggleDetails" plain>
        点击收起
    </van-button>
    
    <!-- 底部图片 -->
    <img src="@/assets/gzdxAd/bottom-image2.jpg" alt="代理商信息" class="bottom-image">

    
  </div>
</template>

<script>
import Vue from "vue";
import { Form, Field, Button, Checkbox, Dialog, Toast } from "vant";

// 注册组件
Vue.use(Form).use(Field).use(Button).use(Checkbox).use(Dialog).use(Toast);

export default {
  name: 'GuangzhouTelecomAd',
  data() {
    return {
      // 表单数据
      formData: {
        name: '',
        phone: '',
        agreed: false
      },
      
      // 倒计时数据
      countdown: {
        hours: 12,
        minutes: 7,
        seconds: 0
      },
      
      // 其他状态
      submitting: false,
      showDetails: true,
      
      // 滚动通知数据
      marqueeData: [
        { name: "张**", phone: "137******3", time: 5, avatar: 'https://via.placeholder.com/32x32/ff6b6b/ffffff?text=张' },
        { name: "李**", phone: "138******6", time: 7, avatar: 'https://via.placeholder.com/32x32/4ecdc4/ffffff?text=李' },
        { name: "欧阳**", phone: "170******1", time: 7, avatar: 'https://via.placeholder.com/32x32/45b7d1/ffffff?text=欧' },
        { name: "陈**", phone: "182******6", time: 9, avatar: 'https://via.placeholder.com/32x32/96ceb4/ffffff?text=陈' },
        { name: "林**", phone: "187******3", time: 10, avatar: 'https://via.placeholder.com/32x32/feca57/ffffff?text=林' },
        { name: "张**", phone: "153******2", time: 10, avatar: 'https://via.placeholder.com/32x32/ff9ff3/ffffff?text=张' },
        { name: "黄**", phone: "138******5", time: 11, avatar: 'https://via.placeholder.com/32x32/54a0ff/ffffff?text=黄' },
        { name: "王**", phone: "136******1", time: 12, avatar: 'https://via.placeholder.com/32x32/5f27cd/ffffff?text=王' },
        { name: "李**", phone: "182******7", time: 12, avatar: 'https://via.placeholder.com/32x32/ff6348/ffffff?text=李' },
        { name: "陈**", phone: "189******8", time: 13, avatar: 'https://via.placeholder.com/32x32/2ed573/ffffff?text=陈' },
      ],
      // 滚动配置
      classOption: {
        singleHeight: 28,
        waitTime: 3000,
      },
      
      // 手机号验证规则
      phoneRules: [
        { required: true, message: '请输入手机号' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码' }
      ]
    }
  },
  
  // 倒计时定时器
  countdownTimer: null,
  
  methods: {
    // 格式化时间
    formatTime(value) {
      return value.toString().padStart(2, '0')
    },
    
    // 启动倒计时
    startCountdown() {
      this.countdownTimer = setInterval(() => {
        this.countdown.seconds--
        if (this.countdown.seconds < 0) {
          this.countdown.seconds = 59
          this.countdown.minutes--
          if (this.countdown.minutes < 0) {
            this.countdown.minutes = 59
            this.countdown.hours--
            if (this.countdown.hours < 0) {
              clearInterval(this.countdownTimer)
              return
            }
          }
        }
      }, 1000)
    },
    
    // 停止倒计时
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },
    
    // 切换详情显示
    toggleDetails() {
      this.showDetails = !this.showDetails
    },
    
    // 显示协议
    showAgreement(type) {
      const agreements = {
        privacy: '个人信息保护政策',
        consent: '单独同意书',
        contract: '中国电信用户入网协议'
      }
      this.$dialog.alert({
        title: agreements[type],
        message: '这里是协议内容...'
      })
    },
    
    // 表单提交
    async onSubmit() {
      if (!this.formData.agreed) {
        this.$toast('请同意相关协议')
        return
      }
      
      this.submitting = true
      
      try {
        // 这里可以添加实际的提交逻辑
        await new Promise(resolve => setTimeout(resolve, 1000)) // 模拟请求
        
        this.$toast('提交成功！我们会尽快为您处理')
        
        // 重置表单
        this.formData.name = ''
        this.formData.phone = ''
        this.formData.agreed = false
        
      } catch (error) {
        this.$toast('提交失败，请重试')
      } finally {
        this.submitting = false
      }
    },
    
    // 响应式字体大小调整
    adjustFontSize() {
      const width = window.innerWidth
      const fontSize = Math.min(width / 750 * 100, 85.33)
      document.documentElement.style.fontSize = fontSize + 'px'
    }
  },
  
  mounted() {
    this.startCountdown()
    this.adjustFontSize()
    window.addEventListener('resize', this.adjustFontSize)
  },
  
  beforeDestroy() {
    this.stopCountdown()
    window.removeEventListener('resize', this.adjustFontSize)
  }
}
</script>

<style scoped>
.telecom-ad {
  background-color: #1c1b19;
  color: #333;
  font-size: 14px;
  line-height: 1.4;
  min-height: 100vh;
}

/* 头部横幅 */
.banner {
  width: 100%;
  display: block;
}

/* 表单容器 */
.form-container {
  margin: 0.2rem;
  border-radius: 0.3rem;
  border: 0.06rem solid #ff8c00;
  background: #fff;
  padding: 0.3rem;
}

/* 倒计时 */
.countdown {
  text-align: center;
  padding: 0.2rem 0;
  font-size: 0.24rem;
  color: #333;
}

.countdown-title {
  margin-right: 0.1rem;
}

.countdown-time {
  display: inline-flex;
  align-items: center;
  gap: 0.05rem;
}

.time-block {
  background-color: #e6e6e6;
  font-size: 0.24rem;
  border-radius: 0.08rem;
  color: #333;
  padding: 0.05rem 0.1rem;
  min-width: 0.3rem;
  text-align: center;
}

.time-colon {
  color: #333;
  font-size: 0.24rem;
  margin: 0 0.05rem;
}

/* 表单样式 */
.form-group {
  margin-bottom: 0.2rem;
}

.form-label {
  display: flex;
  align-items: center;
  margin-bottom: 0.1rem;
  font-size: 0.28rem;
  color: #333;
}

.required {
  color: #ff0000;
  margin-right: 0.05rem;
}

.form-field {
  width: 100%;
  padding: 0.15rem;
  border: 0.02rem solid #ddd;
  border-radius: 0.1rem;
  font-size: 0.28rem;
  background: #fff;
}

.form-field:focus {
  outline: none;
  border-color: #409eff;
}

/* 按钮样式 */
.submit-btn {
  width: 100%;
  padding: 0.2rem;
  background-color: #4818e4;
  color: #fff;
  border: none;
  border-radius: 0.4rem;
  font-size: 0.32rem;
  font-weight: bold;
  margin: 0.2rem 0;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #3a14c7;
}

/* 滚动通知 */
.marquee {
  background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
  color: #fff;
  font-size: 0.28rem;
  margin: 0.2rem 0;
  border-radius: 0.1rem;
  height: 0.8rem;
  overflow: hidden;
  position: relative;
}

.scroll-content {
  height: 100%;
  animation: scroll-up 15s linear infinite;
}

@keyframes scroll-up {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(-100%);
  }
}

.marquee-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.05rem 0.25rem;
  height: 0.5rem;
  box-sizing: border-box;
  white-space: nowrap;
  position: relative;
}

.user-avatar {
  width: 0.32rem;
  height: 0.32rem;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  margin-right: 0.12rem;
  flex-shrink: 0;
  border: 0.02rem solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 0.02rem 0.08rem rgba(0, 0, 0, 0.1);
}

.user-name {
  font-weight: 600;
  margin-right: 0.15rem;
  color: #fff;
  font-size: 0.26rem;
}

.user-phone {
  font-weight: 400;
  margin-right: 0.15rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.24rem;
}

.user-time {
  font-weight: 500;
  color: #fff;
  font-size: 0.24rem;
}

.marquee-item span {
  text-shadow: 0 0.01rem 0.02rem rgba(0, 0, 0, 0.1);
  letter-spacing: 0.01rem;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
  50% {
    opacity: 0.5;
    transform: translateY(-50%) scale(0.8);
  }
}

/* 协议复选框 */
.agreement {
  margin: 0.2rem 0;
  font-size: 0.24rem;
}

.agreement-text a {
  color: #3b9cfd;
  text-decoration: none;
}

/* 产品图片 */
.product-images {
  margin: 0.2rem 0;
}

.product-images img {
  width: 100%;
  display: block;
  margin-bottom: 0.1rem;
}

/* 温馨提示 */
.tip-section {
  background-color: rgba(60, 55, 55, 0);
  margin: 0.2rem;
  padding: 0.2rem;
}

.tip-text {
  color: #b5abab;
  font-size: 12px;
}

/* 详情折叠区域 */
.details-section {
  margin: 0.2rem 0;
}

.details-toggle {
  background: none;
  border: 1px solid #333;
  color: rgb(235, 226, 174);
  padding: 0.1rem 0.2rem;
  border-radius: 0.1rem;
  font-size: 0.24rem;
  cursor: pointer;
  margin: 0.1rem auto;
  display: block;
}

.details-content {
  display: none;
  background: rgba(0,0,0,0.8);
  color: rgb(235, 226, 174);
  padding: 0.3rem 0.5rem;
  font-size:16px;
  line-height: 1.6;
}

.details-content.show {
  display: block;
}

.details-title {
  color: rgb(235, 226, 174);
  font-size: 16px;
  margin: 0.2rem 0;
}

.details-text p {
  margin-bottom: 0.1rem;
}

/* 底部图片 */
.bottom-image {
  width: 100%;
  display: block;
}

/* 通知文本 */
.notice-text {
  font-size: 0.2rem;
  color: #545353;
  margin: 0.2rem 0;
}

/* 工具类 */
.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }
.mb-1 { margin-bottom: 0.1rem; }
.mb-2 { margin-bottom: 0.2rem; }
.mt-1 { margin-top: 0.1rem; }
.mt-2 { margin-top: 0.2rem; }

/* 响应式设计 */
@media (max-width: 480px) {
  .telecom-ad {
    font-size: 12px;
  }
  
  .form-field {
    font-size: 16px; /* 防止iOS缩放 */
  }
}
</style>
